import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {ElementConfiguration} from "./element-configuration";
import {ExpressionInfoConfiguration} from "./expression-info-configuration";

@JsonObject()
export class FormTemplateConfiguration {
    /**
     * The description of the form.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-form-FormTemplate.html#description)
     */
    @JsonProperty()
    declare description: string;
    /**
     * An array of [form element]
     * (https://developers.arcgis.com/javascript/latest/api-reference/esri-form-elements-Element.html) objects that
     * represent an ordered list of form elements.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-form-FormTemplate.html#elements)
     */
    @JsonProperty()
    declare elements?: ElementConfiguration[];
    /**
     * An array of objects or [ExpressionInfo[]](https://developers.arcgis.com/javascript/latest/api-reference/esri-form-ExpressionInfo.html) that reference [Arcade](https://developers.arcgis.com/javascript/latest/arcade/) expressions following the specification defined by the [Form Constraint Profile](https://developers.arcgis.com/javascript/latest/arcade/#constraint) or the [Form Calculation Profile](https://developers.arcgis.com/javascript/latest/arcade/#form-calculation).
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-form-FormTemplate.html#expressionInfos)
     */
    @JsonProperty()
    declare expressionInfos?: ExpressionInfoConfiguration[];
    /**
     * Indicates whether to retain or clear a [form's](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-FeatureForm.html) [field element](https://developers.arcgis.com/javascript/latest/api-reference/esri-form-elements-FieldElement.html) values.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-form-FormTemplate.html#preserveFieldValuesWhenHidden)
     */
    @JsonProperty()
    declare preserveFieldValuesWhenHidden?: boolean;
    /**
     * The string template for defining how to format the title used in a popup.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-form-FormTemplate.html#title)
     */
    @JsonProperty()
    declare title?: string;

    constructor() {}
}
